import React from "react";

export const BoardsIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    width="14"
    height="11"
    viewBox="0 0 14 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M5.25 8.83334V2.16668M5.25 8.83334C5.25 9.56972 4.65305 10.1667 3.91667 10.1667H2.58333C1.84695 10.1667 1.25 9.56972 1.25 8.83334V2.16668C1.25 1.4303 1.84695 0.833344 2.58333 0.833344H3.91667C4.65305 0.833344 5.25 1.4303 5.25 2.16668M5.25 8.83334C5.25 9.56972 5.84695 10.1667 6.58333 10.1667H7.91667C8.65305 10.1667 9.25 9.56972 9.25 8.83334M5.25 2.16668C5.25 1.4303 5.84695 0.833344 6.58333 0.833344H7.91667C8.65305 0.833344 9.25 1.4303 9.25 2.16668M9.25 8.83334V2.16668M9.25 8.83334C9.25 9.56972 9.84695 10.1667 10.5833 10.1667H11.9167C12.653 10.1667 13.25 9.56972 13.25 8.83334V2.16668C13.25 1.4303 12.653 0.833344 11.9167 0.833344H10.5833C9.84695 0.833344 9.25 1.4303 9.25 2.16668"
      stroke="#CCCCCC"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
